<i18n>
{
  "fr": {
    "tool-title": "Produits dérivés",
    "BY_PRODUCTS_REF_ALL": "Réf.",
    "no-data-title": "Aucune donnée",
    "name": "",
    "min": "Min.",
    "max": "Max.",
    "season-min": "Saison",
    "season-max": "Saison",
    "flow-regim": "Régime",
    "fg-1-label": "G",
    "fg-2-label": "NG",
    "fg-3-label": "N",
    "fg-4-label": "NT",
    "fg-5-label": "NP",
    "fg-6-label": "PN",
    "fg-7-label": "PA",
    "fg-8-label": "PB",
    "fg-1-name": "Glaciaire",
    "fg-2-name": "Nivo-glaciaire",
    "fg-3-name": "Nival",
    "fg-4-name": "Nival de transition",
    "fg-5-name": "Nivo-pluvial",
    "fg-6-name": "Pluvio-nival",
    "fg-7-name": "Pluvial A",
    "fg-8-name": "Pluvial B",
    "spring": "Printemps",
    "summer": "Eté",
    "fall": "Automne",
    "winter": "Hiver"
  },
  "de": {

  }
}
</i18n>

<template>
  <div class="tool" id="gw-heads-by-products-point" v-if="show">
    <h3>{{$t('tool-title')}}</h3>
    <md-content class="md-scrollbar main-container" v-if="!loading">
      <md-empty-state
        v-if="nodata"
        class="empty-data"
        md-rounded
        md-icon="graphic_eq"
        :md-label="$t('no-data-title')"
        :md-size="170"
      >
      </md-empty-state>
      <md-table v-if="!nodata">
        <md-table-row>
          <md-table-cell class="separator"></md-table-cell>
          <md-table-cell>{{ $t('min') }}</md-table-cell>
          <md-table-cell class="separator">{{ $t('season-min') }}</md-table-cell>
          <md-table-cell>{{ $t('max') }}</md-table-cell>
          <md-table-cell class="separator">{{ $t('season-max') }}</md-table-cell>
          <md-table-cell class="separator">{{ $t('flow-regim') }}</md-table-cell>
        </md-table-row>
        <md-table-row
          v-for="(d, i) in dataToDisplay"
          :key="`d_${i}`"
        >
          <md-table-cell class="separator"><b>{{ $t(d.name) }}</b></md-table-cell>
          <md-table-cell>{{ d.data.minHeads.toFixed(2) }}</md-table-cell>
          <md-table-cell :class="`se-${d.data.minSeasonOccurence} separator`">
            {{ d.data.minMonthOccurence }}
            <md-tooltip>{{ $t(displaySeason(d.data.minSeasonOccurence)) }} - {{ d.data.minMonthOccurence | displayMonth }}</md-tooltip>
          </md-table-cell>
          <md-table-cell>{{ d.data.maxHeads.toFixed(2) }}</md-table-cell>
          <md-table-cell :class="`se-${d.data.maxSeasonOccurence} separator`">
            {{ d.data.maxMonthOccurence }}
            <md-tooltip>{{ $t(displaySeason(d.data.maxSeasonOccurence)) }} - {{ d.data.maxMonthOccurence | displayMonth }}</md-tooltip>
          </md-table-cell>
          <md-table-cell :class="`fg-${d.data.flowRegime} separator`">
            {{ $t(`fg-${d.data.flowRegime}-label`) }}
            <md-tooltip>{{ $t(`fg-${d.data.flowRegime}-name`) }}</md-tooltip>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-content>
    <div class="loading" v-if="loading">
      <md-progress-spinner class="loading-animation" :md-diameter="40" :md-stroke="5" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import MapStoreMixin from '@/mixins/store/map'

import Layer from '@/components/vue-map/layers/layer'
import SourceProxy from '@/proxies/source'

const NODATA_VALUES = [-3.4028231e+38]

export default {
  name: 'GwHeadsByProductsPoint',
  mixins: [
    MapStoreMixin
  ],
  props: {
    params: {
      type: Object,
      default: () => { return {} }
    }
  },
  filters: {
    displayMonth (index) {
      return moment.localeData('fr').months()[index - 1]
    },
  },
  computed: {
    show () {
      return this.currentGeom !== null && this.currentGeom.type === 'Point'
    },
    nodata () {
      return this.dataToDisplay.length === 0
    },
    dataToDisplay () {
      return this.data.filter((d) => !d.nodata && d.data)
    }
  },
  watch: {
    currentGeom () {
      this.loaded = false
      this.updateTool()
    }
  },
  data() {
    return {
      loading: false,
      loaded: false,
      rasters: [],
      data: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.updateTool()
    })
  },
  methods: {
    updateTool () {
      if (this.loading) return
      if (this.loaded) return this.loading = false
      if (this.currentGeom !== null && this.currentGeom.type === 'Point') this.load()
      else this.removeTool()
    },
    removeTool () {

    },
    load () {
      this.loaded = false
      this.loading = true
      this.rasters = []
      this.data = []
      this.fetchRasters(this.params.sourcesToFetch).then(() => {
        this.fetchData().then(() => {
          this.loading = false
          this.loaded = true
        }).catch(this.handleError)
      }).catch(this.handleError)
    },
    // Récupération des sources de données rasters et création de leur objet respectif
    fetchRasters (sourceIds) {
      return new Promise((resolve, reject) => {
        SourceProxy.getSources(sourceIds).then((sources) => {
          sources.forEach((source) => {
            this.rasters.push(Layer.fromSource(source))
          })
          resolve()
        }).catch(reject)
      })
    },
    fetchData () {
      return new Promise((resolve, reject) => {
        let toFetch = []
        let params = []
        this.data = []
        this.rasters.forEach((raster) => {
          params = []
          params['INFO_FORMAT'] = 'json'
          toFetch.push(raster.getFromGeom(this.mapRef, this.currentGeom, params))
        })

        Promise.all(toFetch).then((response) => {
          response.forEach((data, index) => {
            this.data.push({
              name: this.rasters[index].geoserverConfig.sourceName,
              data: data,
              nodata: NODATA_VALUES.includes(data.minHeads)
            })
          })
          resolve()
        }).catch(reject)
      })
    },
    displaySeason (index) {
      switch (index) {
        case 1: return 'winter'
        case 2: return 'spring'
        case 3: return 'summer'
        case 4: return 'fall'
      }
    }
  }
}

</script>

<style lang="scss">
 #gw-heads-by-products-point {
    .empty-data {
      margin-top: 15px;
      margin-bottom: 15px;

      .md-icon {
        width: 80px;
        min-width: 80px;
        font-size: 80px !important;
      }
      .md-empty-state-label {
        font-size: 18px;
        line-height: 18px;
      }

      &.md-empty-state-leave-active {
        display: none !important;
      }
    }

    .md-table-cell {
      height: 30px;
      text-align: center;

      &.separator {
        border-right: 1px solid #e0e0e0;
      }
    }

    .md-table-cell-container {
      padding: 6px 2px 6px 2px;
    }
 }
</style>

<style lang="scss" scoped>
  #gw-heads-by-products-point {
    .fg-1 { background-color: rgba(135, 135, 135, 0.7); color: white; }
    .fg-2 { background-color: rgba(224, 224, 224, 0.7) }
    .fg-3 { background-color: rgba(255, 255, 179, 0.7) }
    .fg-4 { background-color: rgba(236, 231, 179, 0.7) }
    .fg-5 { background-color: rgba(209, 229, 240, 0.7) }
    .fg-6 { background-color: rgba(146, 197, 222, 0.7) }
    .fg-7 { background-color: rgba(67, 147, 195, 0.7); color: white; }
    .fg-8 { background-color: rgba(33, 102, 172, 0.7); color: white; }

    .se-1 { background-color: rgba(223, 194, 125, 0.7) ; }
    .se-2 { background-color: rgba(199, 234, 229, 0.7) ; }
    .se-3 { background-color: rgba(128, 205, 193, 0.7) ; }
    .se-4 { background-color: rgba(246, 232, 195, 0.7) ; }
  }
</style>
